import React, { FC, memo } from "react";
import { ButtonProps } from "./Button.props";
import P from "../P/P";

const buttonStyles: Record<NonNullable<ButtonProps["appearance"]>, string> = {
	main: "bg-light-bgColor dark:bg-dark-bgColor text-white hover:bg-opacity-90",
	primary:
		"bg-light-mainColor dark:bg-dark-mainColor text-light-whiteText dark:text-dark-whiteText hover:bg-opacity-90",
	secondary:
		"bg-light-grayOne text-light-textColor dark:text-dark-textColor dark:bg-dark-grayOne hover:bg-light-grayTwo",
	red: "bg-light-error text-light-whiteText dark:text-dark-whiteText dark:bg-dark-error",
	white: "bg-white text-[#161616] border border-white",
	outlined:
		"bg-transparent border border-mainColor text-mainColor hover:bg-light-mainColor",
	disabled:
		"bg-transparent text-light-grayThree cursor-not-allowed border border-light-grayTwo",
	underline: "bg-transparent border-b border-mainColor text-mainColor",
	notStyled: "bg-transparent text-mainColor",
};

const Button: FC<ButtonProps> = ({
	children,
	appearance = "main",
	icon = null,
	rightIcon = null,
	paddingX = "px-6",
	paddingY = "py-2.5",
	className = "",
	width = "w-max",
	rounded = "rounded-full",
	fontSize = "p3",
	textType = "regular",
	textClassName = "",
	type = "button",
	disabled,
	...props
}) => {
	const isDisabled = appearance === "disabled" || !!disabled;

	const buttonClasses = `
		transition-all duration-300 font-medium flex items-center justify-center gap-2 
		${width} ${paddingX} ${paddingY} ${rounded} 
		${buttonStyles[appearance as NonNullable<ButtonProps["appearance"]>]} 
		${className}
	`;

	return (
		<button
			className={buttonClasses}
			type={type}
			disabled={isDisabled}
			{...props}
		>
			{icon && <span className="mr-2">{icon}</span>}

			{children && (
				<P
					size={fontSize}
					type={textType}
					className={`${textClassName} ${appearance === "disabled" ? "cursor-not-allowed" : "cursor-pointer"}`}
				>
					{children}
				</P>
			)}

			{rightIcon && <span className="ml-2">{rightIcon}</span>}
		</button>
	);
};

export default memo(Button);
